import { post } from '../../common/httpUtil'
import { SafeStorage } from '../../common/storageUtil'

const LS_KEY = 'feedback_'
/**
@param cfg { serviceUrl: String, conferenceId: String }
@param subjectId String
@param answers  { [questionId: String]: [answer: Any] }
*/
export function sendFeedback(cfg, subjectId, answers) {
  console.log('sendFeedback', { cfg, subjectId, answers })
  const body = {
    appId: cfg.conferenceId,
    subjectId,
    answers,
  }
  SafeStorage.set(LS_KEY + subjectId, answers)
  return post(cfg.serviceUrl, body).then(result => {
    console.log('feedback sent', result)
  })
}

export function clearLocalFeedback(subjectId) {
  return SafeStorage.remove(LS_KEY + subjectId)
}

export function getLocalFeedback(subjectId) {
  return SafeStorage.get(LS_KEY + subjectId)
}



// WEBPACK FOOTER //
// ./src/addons/feedback/feedbackService.js